
import { PJAxios, setOfflineBundles, usePJStore, useCoreContext } from '@jaf/jaf-react-core';
import { Editor } from 'primereact/editor';
import React, { useEffect, useState } from 'react';

import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

import { InputTextarea } from 'primereact/inputtextarea';
import { flushCache } from '../../../api/ChatbotApi';
import isFilled from '../../Utils';

function Faq(props) {

    const getText = usePJStore((state) => state.i18n_getText)
    const bundles = useCoreContext((state) => state.i18n.bundles)
    const italianTitle = bundles.it[props.selectedNode.title];
    const englishTitle = bundles.en[props.selectedNode.title];
    const [domanda_it, setDomanda_it] = useState(bundles.it[props.selectedNode.question] || "");
    const [domanda_en, setDomanda_en] = useState(bundles.en[props.selectedNode.question] || "");
    //console.log(bundles.en[props.selectedNode.question])
    const [risposta_it, setRisposta_it] = useState(bundles.it[props.selectedNode.answer] || "");
    const [risposta_en, setRisposta_en] = useState(bundles.en[props.selectedNode.answer] || "");

    const [gruppo, setGruppo] = useState(null);
    const [gruppi, setGruppi] = useState(props.gruppi);

    const [gruppiAll, setGruppiAll] = useState(props.gruppi);

    const [nodeLoaded, setNodeLoaded] = useState(false);

    const [loading, setLoading] = useState(false);

    const [modifiedItems, setModifiedItems] = useState([]);
    const [chiudi, setChiudi] = useState(false);

    const dbTest = usePJStore((state) => state.appInfo_dbTest);

    useEffect(() => {
        if (gruppiAll == undefined) {
            getGroups()
        }
    }, [gruppiAll]);

    const getGroups = () => {
        PJAxios().post('/gestioneConfigurazioni/getGroups', { type: "Q" }).then((res) => {

            let items = res.data;
            items.unshift({ tag: getText("ALL"), conteggio: 0, filter: false })

            setGruppiAll(items);
            if (gruppi == undefined) {
                setGruppi(items)
            }

        });
    }

    useEffect(() => {
        if (gruppiAll != null && gruppiAll.length > 1) {
            console.log("gruppiAll", gruppiAll)
            setGruppo(gruppiAll[1]);
        }
    }, [gruppiAll]);


    useEffect(() => {
        if (modifiedItems.length > 0) {
            salvaTutto();
        }
    }, [modifiedItems]);



    useEffect(() => {

        //console.log(props.selectedNode)
        if (props.selectedNode != null && !props.createAndAdd) {
            setDomanda_it(bundles.it[props.selectedNode.question]);
            setDomanda_en(bundles.en[props.selectedNode.question]);

            setRisposta_it(bundles.it[props.selectedNode.answer]);
            setRisposta_en(bundles.en[props.selectedNode.answer]);

            if (props.selectedNode.tag != null) {
                setGruppo(props.selectedNode.tag)
            }


            if (sessionStorage.getItem("savedModifiedItems") != null) {

                var arr = JSON.parse(sessionStorage.getItem("savedModifiedItems"))
                arr.forEach(item => {
                    item.forEach((element) => {
                        if (props.selectedNode.idItem == element.id_item) {

                            if (element.id_element == 'domanda_it') {
                                setDomanda_it(element.new_val)
                            } else if (element.id_element == 'domanda_en') {
                                setDomanda_en(element.new_val)
                            } else if (element.id_element == 'risposta_it') {
                                setRisposta_it(element.new_val)
                            } else if (element.id_element == 'risposta_en') {
                                setRisposta_en(element.new_val)
                            }

                        }
                    })

                });
            }

        }

        setTimeout(() => {
            try {
                props.onNodeLoaded();
            } catch (e) {

            }
            setNodeLoaded(true);
        }, 500);
    }, [props.selectedNode]);


    const salva = () => {

        if (props.isNew) {
            let request = {
                domanda_it,
                domanda_en,
                risposta_it,
                risposta_en,
                gruppo: gruppo.tag != null ? gruppo.tag : gruppo,
                idConfig: props.idConfig
            }
            salvaFaq(request);

        } else {
            let modifiedItems = [];
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "domanda_it", op_type: "mod_el", obj_type: "faq", new_val: domanda_it, gruppo: gruppo.tag != null ? gruppo.tag : gruppo })
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "domanda_en", op_type: "mod_el", obj_type: "faq", new_val: domanda_en, gruppo: gruppo.tag != null ? gruppo.tag : gruppo })
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "risposta_it", op_type: "mod_el", obj_type: "faq", new_val: risposta_it, gruppo: gruppo.tag != null ? gruppo.tag : gruppo })
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "risposta_en", op_type: "mod_el", obj_type: "faq", new_val: risposta_en, gruppo: gruppo.tag != null ? gruppo.tag : gruppo })
            setModifiedItems(modifiedItems);
        }
    }

    const salvaEChiudi = () => {
        setChiudi(true);
        salva();
    }

    const onSave = (tematica, outcome, chiudi) => {
        props.onSave(tematica, outcome, chiudi);
    }

    const salvaTutto = () => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedItems, idConfig: props.idConfig }).then((res) => {

            var smi = [];
            if (sessionStorage.getItem("savedModifiedItems") != null) {
                smi = JSON.parse(sessionStorage.getItem("savedModifiedItems"))
            }
            smi.push(modifiedItems)

            sessionStorage.setItem("savedModifiedItems", JSON.stringify(smi));

            setLoading(false);
            onSave(props.tematica, true, chiudi);
            setModifiedItems([]);
            flushCache(dbTest);
        });
    }


    const salvaFaq = (request) => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/createFaq', request).then((res) => {
            setModifiedItems([]);

            let question = "Q_" + res.data + ":QUESTION";
            let answer = "Q_" + res.data + ":ANSWER";

            setOfflineBundles({
                it: {
                    [question]: request.domanda_it,
                    [answer]: request.risposta_it
                }, en: {
                    [question]: request.domanda_en,
                    [answer]: request.risposta_en
                }
            })

            flushCache(dbTest);

            if (props.createAndAdd) {
                props.onFaqCreated(res.data, true)
            } else {
                setLoading(false);
                onSave(props.tematica, true);
                props.onFaqCreated(res.data, false)
            }

        });

    }

    const searchGroup = (event) => {

        setTimeout(() => {
            var ret = [];
            gruppiAll.forEach((item) => {
                if (item.tag.toLowerCase().indexOf(event.query.toLowerCase()) !== -1) {

                    let question = {
                        tag: item.tag,
                        conteggio: item.conteggio
                    }

                    ret.push(question);
                }
            })

            setGruppi(ret);
        }, 250);

    }

    const itemTemplate = (item) => {
        return (
            <div >
                <div className="formgroup-inline col-12 md:col-12">
                    <div>{item.tag}</div>
                </div>
            </div>
        )
    }

    const confirmOperation = (event) => {
        props.onConfirmOperation(event)
    }

    const validateForm = () => {
        var ret = isFilled(domanda_it) && isFilled(risposta_it) && isFilled(domanda_en) && isFilled(risposta_en)
        ret = ret && (gruppo != null && !("Tutti" == gruppo))
        return ret;

    }


    const [risposta_itToggle, setRisposta_itToggle] = useState(true);
    const [risposta_enToggle, setRisposta_enToggle] = useState(true);

    useEffect(() => {
        if (!risposta_itToggle) {
            const interval = setInterval(() => {
                setRisposta_itToggle(!risposta_itToggle);
            }, 250);
            return () => clearInterval(interval);
        }
    }, [risposta_itToggle]);

    useEffect(() => {
        if (!risposta_enToggle) {
            const interval = setInterval(() => {
                setRisposta_enToggle(!risposta_enToggle);
            }, 250);
            return () => clearInterval(interval);
        }
    }, [risposta_enToggle]);

    const updateRisposta_it = (e) => {
        if (risposta_itToggle) {
            setRisposta_it(e.htmlValue)
            setRisposta_itToggle(!risposta_itToggle);
        }
    }

    const updateRisposta_en = (e) => {
        if (risposta_enToggle) {
            setRisposta_en(e.htmlValue)
            setRisposta_enToggle(!risposta_enToggle);
        }
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <div className='card'>
                    <h4 style={{ textAlign: "left", textTransform: "uppercase" }}><b>{getText("DOMANDA_RISPOSTA")}</b></h4>
                    <p style={{ textAlign: "left" }}>{getText("DOMANDA_RISPOSTA_HELPER")}</p>
                    <div>&nbsp;</div>
                    <div className="p-fluid formgroup-inline">

                        <div className="col-6 md:col-6">
                            <InputTextarea autoResize rows={5} cols={30} className="width500px block mb-2 " id="name" value={domanda_it} onChange={(e) => setDomanda_it(e.target.value)} placeholder={getText("INSERISCI_DOMANDA_IT_PLACEHOLDER")} />
                            <Editor

                                style={{
                                    height: '320px',
                                    border: '1px solid #ced4da',
                                    borderRadius: '6px',
                                    overflow: 'hidden',
                                    backgroundColor: '#f8f9fa' // Colore dietro la toolbar
                                }}
                                // Stile specifico per l'area dove si scrive
                                contentStyle={{
                                    height: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#495057',
                                    borderTop: '1px solid #ced4da' // Separa la toolbar dal testo
                                }}
                                length="100" value={risposta_it} onTextChange={(e) => updateRisposta_it(e)} placeholder={getText("INSERISCI_RISPOSTA_IT_PLACEHOLDER")} />
                        </div>
                        <div className="col-6 md:col-6">
                            <InputTextarea autoResize rows={5} cols={30} className="width500px block mb-2 " id="name" value={domanda_en} onChange={(e) => setDomanda_en(e.target.value)} placeholder={getText("INSERISCI_DOMANDA_EN_PLACEHOLDER")} />
                            <Editor style={{
                                height: '320px',
                                border: '1px solid #ced4da',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa' // Colore dietro la toolbar
                            }}
                                // Stile specifico per l'area dove si scrive
                                contentStyle={{
                                    height: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#495057',
                                    borderTop: '1px solid #ced4da' // Separa la toolbar dal testo
                                }} value={risposta_en} onTextChange={(e) => updateRisposta_en(e)} placeholder={getText("INSERISCI_RISPOSTA_EN_PLACEHOLDER")} />
                        </div>
                        <p>&nbsp;</p>
                    </div>
                    <div>
                        <AutoComplete style={{ width: "95%" }} field="tag" dropdown placeholder={getText("INSERISCI_GRUPPO_PLACEHOLDER")} value={gruppo} suggestions={gruppi} completeMethod={searchGroup} onChange={(e) => { setGruppo(e.value) }} itemTemplate={itemTemplate} />
                    </div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>

                    <div className="p-fluid grid">
                        <div className="field col-3 md:col-3 formgroup-inline">
                            <div>
                                <Button disabled={!validateForm()} label={getText("SALVA")} size="large" className="p-button p-button-primary" onClick={salva} icon="pi pi-save" /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </div>

                            {props.dialog == true &&

                                <div>
                                    <Button disabled={!validateForm()} label={getText("SALVA_E_CHIUDI")} size="large" className="p-button p-button-primary" onClick={salvaEChiudi} icon="pi pi-save" />
                                </div>
                            }
                        </div>
                        <div className="field col-3 md:col-3">
                            {!props.isNew && props.allowDelete && <Button icon="pi pi-trash" className="p-button-primary" label={getText("ELIMINA")} onClick={confirmOperation} ></Button>}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Faq
